import { z } from "zod";
import { appIdSchema, correlationIdSchema, incidentIdSchema, isoTimestampSchema, opaqueRefSchema, runIdSchema, userIdSchema, } from "./identifiers.js";
export const agentIncidentSchema = z
    .object({
    schemaVersion: z.literal(1),
    id: incidentIdSchema,
    userId: userIdSchema,
    appId: appIdSchema,
    correlationId: correlationIdSchema,
    source: z.enum([
        "health",
        "verification",
        "runtime",
        "function",
        "job",
        "agent_feed",
        "user_report",
    ]),
    kind: z.string().trim().min(1).max(100),
    severity: z.enum(["info", "warning", "error", "critical"]),
    title: z.string().trim().min(1).max(200),
    summary: z.string().trim().min(1).max(2_000),
    observedAt: isoTimestampSchema,
    evidenceRefs: z.array(opaqueRefSchema).max(20),
    provenance: z
        .object({
        trusted: z.boolean(),
        sourceEventId: z.string().trim().min(1).max(200),
    })
        .strict(),
    policy: z
        .object({
        unattendedEligible: z.boolean(),
        reason: z.string().trim().min(1).max(500),
    })
        .strict(),
})
    .strict();
export const appLeaseSchema = z
    .object({
    schemaVersion: z.literal(1),
    leaseId: z.uuid(),
    appId: appIdSchema,
    runId: runIdSchema,
    acquiredAt: isoTimestampSchema,
    expiresAt: isoTimestampSchema,
    generation: z.number().int().positive(),
})
    .strict();
/**
 * Control-plane attestation used before an unattended run can be presented as
 * a successful repair. It refers only to durable platform records; the
 * agent's own final message is never sufficient evidence.
 */
export const repairVerificationEvidenceSchema = z
    .object({
    schemaVersion: z.literal(1),
    userId: userIdSchema,
    appId: appIdSchema,
    runId: runIdSchema,
    confirmed: z.boolean(),
    deploymentId: z.uuid().nullable(),
    artifactSha256: z.string().regex(/^[a-f0-9]{64}$/).nullable(),
    verificationId: z.uuid().nullable(),
    verifiedAt: isoTimestampSchema.nullable(),
    evidenceRefs: z.array(opaqueRefSchema).max(20),
})
    .strict();
//# sourceMappingURL=incidents.js.map